var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "7cz9xwyw6a",
    d: "M19.792 4.167h-4.355C15 2.958 13.854 2.083 12.5 2.083c-1.354 0-2.5.875-2.938 2.084H5.208c-1.146 0-2.083.937-2.083 2.083v14.583c0 1.146.938 2.084 2.083 2.084h14.584c1.145 0 2.083-.938 2.083-2.084V6.25c0-1.146-.938-2.083-2.083-2.083zm-7.292 0c.573 0 1.042.468 1.042 1.041S13.072 6.25 12.5 6.25c-.573 0-1.042-.469-1.042-1.042 0-.573.47-1.041 1.042-1.041zm2.083 14.583H7.292v-2.083h7.291v2.083zm3.125-4.167H7.292V12.5h10.416v2.083zm0-4.166H7.292V8.333h10.416v2.084z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79 -25) translate(79 25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "miiqzu6mnb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7cz9xwyw6a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#miiqzu6mnb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H52.083V52.083H0z",
    transform: "translate(-13.542 -13.542)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAssignment);
export default __webpack_public_path__ + "static/media/ic-assignment.24b441e9f29b4980065a1399d69401d2.svg";
export { ForwardRef as ReactComponent };